<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.name"
  >
     <div class="text-right leading-tight hidden sm:flex items-center space-x-2">
      <span class="font-semibold">{{ tenantName }}</span>
      <span class="text-gray-400">|</span>
      <span class="text-sm text-gray-600">{{ activeUserInfo.name?.trim() }}</span>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <vs-avatar
          v-if="activeUserInfo.photoURL"
          :src="activeUserInfo.photoURL"
        />
        <vs-avatar
          v-if="!activeUserInfo.photoURL"
          :text="activeUserInfo.name.trim()"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/profile').catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
       tenantName: localStorage.getItem('tenantName') || '',
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    tenantInfo() {
      return localStorage.getItem('tenantName')
          ? localStorage.getItem('tenantName')
          : this.$store.state.AppActiveTenant ? this.$store.state.AppActiveTenant.name : ''
    },
  },
  mounted() {
    window.addEventListener('tenant-updated', this.updateTenantName)
  },
  beforeUnmount() {
    window.removeEventListener('tenant-updated', this.updateTenantName)
  },
  methods: {
    updateTenantName() {
      this.tenantName = localStorage.getItem('tenantName') || ''
    },
    logout() {
      if (localStorage.getItem('accessToken')) {
        localStorage.removeItem('accessToken')
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change('admin')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('loggedIn')
      localStorage.removeItem('tokenExpiry')
      localStorage.removeItem('tenantName')
      localStorage.removeItem('readOnlySession')
      this.$router.push('/login').catch(() => {})
    },
  },
}
</script>
